export default __webpack_public_path__ + "static/media/CF21A42C-3A5E-4CB2-BE0C-360D5A92EF17_1_105_c.27eb65ba.jpeg";